import instance from "../../axios/axios-user";
import { NewsFeedProps } from "../../redux/slices/newsfeed/NewsFeed";
import { API_PATHS } from "../api_paths";

const getNewsFeedPosts = ({
  page,
  page_size,
  sort_by,
  circle_id,
}: NewsFeedProps.getNewsFeedPostsPayload) =>
  instance(
    API_PATHS.newsfeed.getNewsFeedPosts +
      page +
      `?${new URLSearchParams({
        page_size: String(page_size),
        sort_by,
        circle_id,
      }).toString()}`
  );

export const NEWSFEED = { getNewsFeedPosts };
